import React,{useState} from 'react'
import 'react-calendar/dist/Calendar.css';
import Calendar from 'react-calendar';
import moment from 'moment';
import { Dialog, DialogContent } from '@mui/material';

function CalendarDateInput({selectedDate,setSelectedDate}) {

    const [dialogStatus, setDialogStatus] = useState(false);  
    const handleDateChange = (e) =>{
        setSelectedDate(e);
        setDialogStatus(false);
    }

    return (
    <>
        <Dialog
          open={dialogStatus}
          keepMounted
          onClose={()=>setDialogStatus(false)}
          fullWidth={true}
          maxWidth="md"
        >
          <DialogContent>
            <Calendar onChange={handleDateChange} value={selectedDate} />
          </DialogContent>
        </Dialog>
        <span>
            <button className='btn btn-primary' onClick={()=>setDialogStatus(true)} >{moment(selectedDate).format("dddd, YYYY-MM-DD")}</button>
        </span>
    </>
  )
}

export default CalendarDateInput